import { Link } from "react-router-dom";
import "./Footer.css";

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="site-footer-top">
        <Link to="/" aria-label="Volver al inicio">
          <img
            src="/images/branding/logo_imalandia.png"
            alt="Imalandia"
            className="site-footer-logo"
          />
        </Link>

        <p className="site-footer-text">
          Imanes personalizados, collages magnéticos, marcos y accesorios
          creados a partir de tus fotos favoritas.
        </p>
      </div>

      <div className="site-footer-links">
        <Link to="/imanes-personalizados-con-fotos">Crear imanes</Link>

        <Link to="/editor">Crear collage</Link>

        <Link to="/marcos-individuales">Marcos individuales</Link>

        <Link to="/marco-duo">Marco Duo</Link>

        <Link to="/marco-mosaico">Marco Mosaico</Link>

        <Link to="/marco-secuencia">Marco Secuencia</Link>


        <Link to="/ofertas">Ofertas</Link>

        <Link to="/#tienda">Tienda</Link>

        <Link to="/ayuda">Ayuda</Link>

        <Link to="/contacto">Contacto</Link>
      </div>

      <div className="site-footer-legal">
        <Link to="/aviso-legal">Aviso legal</Link>

        <Link to="/privacidad">Política de privacidad</Link>

        <Link to="/terminos">Términos y condiciones</Link>

        <Link to="/devoluciones">Política de devoluciones</Link>
      </div>

      <div className="site-footer-socials">
        {/*<a
          href="https://instagram.com/imalandia.com"
          target="_blank"
          rel="noreferrer"
          aria-label="Instagram de Imalandia"
        >
          <img src="/icons/instagram.svg" alt="" />
        </a>*/}

        <a
          href="https://tiktok.com/@imalandia.com"
          target="_blank"
          rel="noreferrer"
          aria-label="TikTok de Imalandia"
        >
          <img src="/icons/tiktok.svg" alt="" />
        </a>
      </div>

      <p className="site-footer-copy">© 2026 Imalandia</p>
    </footer>
  );
}
